import './App.scss';
import './i18n';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Footer } from './components/Footer/Footer.tsx';
import Month from './components/Month/Month.tsx';
import Year from './components/Year/Year.tsx';
import AdminPage from './pages/AdminPage/AdminPage.tsx';
import Home from './pages/HomePage/Home.tsx';
import MyDay from './pages/MyDayPage/MyDayPage.tsx';
import MydayDetails from './pages/MyDayPage/MydayDetails.tsx';
import { ShowExportOfAllDays } from './pages/MyDayPage/ShowExportOfAllDays.tsx';
import MyPasswords from './pages/MyPasswords/MyPasswords.tsx';
import ProfilePage from './pages/ProfilePage/ProfilePage.tsx';
import ShowLogs from './pages/ShowLogs.tsx';
import Signout from './pages/Signout.tsx';
const queryClient = new QueryClient();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/registrations" element={<Month />} />
          <Route path="/year" element={<Year />} />
          <Route path="/myday" element={<MyDay />} />
          <Route path="/mypasswords" element={<MyPasswords />} />
          <Route path="/mydaydetails/:id" element={<MydayDetails mydayId={0} isExport={false} />} />
          <Route path="/signout" element={<Signout />} />
          <Route path="/logs" element={<ShowLogs />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/export" element={<ShowExportOfAllDays />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
      <Footer />
    </QueryClientProvider>
  );
}
